import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { QUALITY_CHECKLIST_API } from "../apiRoutes";

interface UseGetQualityChecklistWithItemByProjectProps {
  projectId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getQualityChecklistWithItemByProject = async (projectId: string) => {
  return await axiosAuth.get(`${QUALITY_CHECKLIST_API}/project/${projectId}/with-items`);
};

const useGetQualityChecklistWithItemByProject = ({
  projectId,
  queryParams,
}: UseGetQualityChecklistWithItemByProjectProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["quality-checklist-with-item", projectId],
    queryFn: () => getQualityChecklistWithItemByProject(projectId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetQualityChecklistWithItemByProject;
